import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import NavigationBlock from './NavigationBlock/NavigationBlock';
import NavigationBlockProviders from './NavigationBlock/NavigationBlockProviders/NavigationBlockProviders';
import NavigationBlockCategories from './NavigationBlock/NavigationBlockCategories/NavigationBlockCategories';
import { getDataTestAttributes } from '../../utils/testing-locators';
import { TAB_NAVIGATION } from '../../constants/dataTestIds';
import { NAMESPACES } from '../../constants/namespaces';
import { useMainNavigation } from './hooks';
import { sidebarMenuItemLimitsSelector } from '../../redux/reducers/app/configuration';
import { ANALYTICS_SCHEMA_URLS } from '../../constants/analytics';
import { FEATURES } from '../../constants/featureToggling';

import styles from './Navigation.module.css';

const ANALYTICS_DATA_NAV_ITEM = {
  schema: ANALYTICS_SCHEMA_URLS.NAVIGATION_CLICK,
};

export const Navigation = () => {
  const sections = useMainNavigation();
  const isStickySideMenu = useFeatureIsOn(FEATURES.ENABLED_STICKY_SIDE_MENU);

  const { categories, providers } = useSelector(sidebarMenuItemLimitsSelector);

  return (
    <nav
      role="navigation"
      {...getDataTestAttributes(TAB_NAVIGATION)}
      style={{ background: 'var(--background-main)' }}
      className={classNames({
        [styles.sticky]: isStickySideMenu,
      })}
    >
      <NavigationBlock
        namespace={NAMESPACES.NAV}
        navItems={sections}
        analyticsDataItem={ANALYTICS_DATA_NAV_ITEM}
      />

      {categories ? <NavigationBlockCategories limit={categories} /> : null}

      {providers ? <NavigationBlockProviders limit={providers} /> : null}
    </nav>
  );
};

export default Navigation;
